var _filter, _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-2qgrgz",
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: ":r1g:-filter",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21,
    width: 17.9082,
    x: 3,
    y: 2
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.345098 0 0 0 0 0 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2978_44190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2978_44190",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r1g:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 4,
    x2: 21.5591,
    y1: 4.5158,
    y2: 18.5565
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#:r1g:-filter)",
    className: "Ui-outlineFilter"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m16.4622 3.41042c-.5472-.54723-1.4345-.54723-1.9817 0l-7.22856 7.22858c-.54723.5472-.54723 1.4345 0 1.9817l3.03566 3.0356c.5472.5472 1.4344.5472 1.9817 0l7.2285-7.22856c.5473-.54723.5473-1.43447 0-1.9817z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.4622 3.41042c-.5472-.54723-1.4345-.54723-1.9817 0l-7.22856 7.22858c-.54723.5472-.54723 1.4345 0 1.9817l3.03566 3.0356c.5472.5472 1.4344.5472 1.9817 0l7.2285-7.22856c.5473-.54723.5473-1.43447 0-1.9817z",
    fill: "url(#:r1g:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m4.43312 16.1023 1.04439-1.0444 2.38851 2.3877-1.04524 1.0444c-.27692.2777-.65263.4331-1.04439.4331-.39175 0-.76746-.1554-1.04523-.4331l-.29804-.2981c-.27693-.2769-.43312-.6526-.43312-1.0452 0-.3918.15619-.7675.43312-1.0444z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.43312 16.1023 1.04439-1.0444 2.38851 2.3877-1.04524 1.0444c-.27692.2777-.65263.4331-1.04439.4331-.39175 0-.76746-.1554-1.04523-.4331l-.29804-.2981c-.27693-.2769-.43312-.6526-.43312-1.0452 0-.3918.15619-.7675.43312-1.0444z",
    fill: "url(#:r1g:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m6.97022 13.5652-.59691.5969 2.38766 2.3877.59691-.5969z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.97022 13.5652-.59691.5969 2.38766 2.3877.59691-.5969z",
    fill: "url(#:r1g:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m15.5105 21c1.3819 0 2.5022-1.1203 2.5022-2.5023 0-1.3819-1.1203-2.5022-2.5022-2.5022-1.382 0-2.5023 1.1203-2.5023 2.5022 0 1.382 1.1203 2.5023 2.5023 2.5023z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5105 21c1.3819 0 2.5022-1.1203 2.5022-2.5023 0-1.3819-1.1203-2.5022-2.5022-2.5022-1.382 0-2.5023 1.1203-2.5023 2.5022 0 1.382 1.1203 2.5023 2.5023 2.5023z",
    fill: "url(#:r1g:-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Ui-outline",
    d: "m5.831 14.7043-.35355-.3534-.35349.3535-1.04439 1.0443c-.37036.3704-.57957.8732-.57957 1.398 0 .5255.2091 1.0283.57957 1.3988l.29803.298c.37158.3716.87448.5796 1.39879.5796.52405 0 1.02718-.2078 1.3982-.5798.0001-.0001.00019-.0002.00028-.0003l1.04456-1.0437.3539-.3536-.35382-.3537zm4.14049 1.3421c.74501.7058 1.92121.6936 2.65131-.0365l7.2286-7.22861c.7425-.74249.7425-1.94631 0-2.6888l-3.0356-3.03562-.3536.35355.3536-.35355c-.7425-.74249-1.9463-.74249-2.6888 0l-7.22862 7.22853c-.73509.7351-.74242 1.9224-.02198 2.6665l-.25973.2597-.59692.597-.35355.3535.35355.3536 2.38767 2.3876.35355.3536.35355-.3536.59692-.5969zm5.53901 5.4536c1.6581 0 3.0022-1.3442 3.0022-3.0023s-1.3441-3.0022-3.0022-3.0022-3.0023 1.3441-3.0023 3.0022 1.3442 3.0023 3.0023 3.0023z",
    stroke: "#5800e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.dc12e47fb73bbd6e43efbb07c1afd7a4.svg";
export { ForwardRef as ReactComponent };